import { connect } from 'react-redux';
import Appreciate from '../components/appreciate/appreciate';
import * as TranslationsActions from '../actions/translationsActions';
import * as CommentsActions from '../actions/commentsActions';
import * as ActionCreators from '../actions/actionCreators';

const mapStateToProps = state => ({
  translations: state.translations,
  privacyPolicyLink: state.privacyPolicyLink,
  comment: state.comment,
  displayFinalMessage: state.displayFinalMessage,
  videoUploadSuccessful: state.videoUploadSuccessful,
  error: state.error,
  basePath: state.basePath,
  videoFileName: state.videoFileName,
  spinnerDisplay: state.spinnerDisplay,
  locale: state.locale,
});

const mapDispatchToProps = dispatch => ({
  updateLocale: () => {
    dispatch(TranslationsActions.updateLocale());
  },
  allDoneClick: toggle => {
    dispatch(ActionCreators.allDoneClick(toggle));
  },
  submitVideo: event => {
    dispatch(CommentsActions.submitVideo(event));
  },
  captureFileName: event => {
    dispatch(CommentsActions.captureFileName(event));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Appreciate);
